module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hant-2-dark-e7325c27b84cf1831965cffb9294125f.jpg";